import { withTranslation } from "react-i18next";

import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import Common from "../../Models/Common";
class SideBar extends React.Component {
    constructor(props) {
        super(props);
        // console.log("sidebar ccccccccccaaaaaaaaleed::");
        if (!localStorage.getItem('info')) {
            this.props.history.push('/login/seller');
        }
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            local_storage: [],
            user: logged_user,
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    handleSubmit(e) {
        e.preventDefault();
        window.localStorage.removeItem('info')
        window.localStorage.removeItem('pro_pic')
        localStorage.clear();
        // this.props.history.push('/');
        window.location.href = '/';
    }

    profilePic() {
        var x = JSON.parse(localStorage.getItem('info'))
        // console.log(">>>>>>>>>>>> ", x);
        if (localStorage.getItem('pro_pic')) {
            var pro_pic = JSON.parse(localStorage.getItem('pro_pic'))
            return (
                <div style={{ height: '170px', marginLeft: '-17px', marginRight: '20px' }}>
                    <img className="" alt="" src={Common.baseUrl+ pro_pic} style={{ width: "170px", height: "170px", objectFit: 'cover', borderRadius: '50%' }} />
                </div>
            )
        } else {
            return (
                <div style={{ height: '170px', marginLeft: '-17px', marginRight: '20px' }}>
                    <img className="" alt="" src={Common.baseUrl+x.img_sidebar} style={{ width: "170px", height: "170px", objectFit: 'cover', borderRadius: '50%' }} />
                </div>
            )
        }
    }

    profileName() {
        var x = JSON.parse(localStorage.getItem('info'))
        if (localStorage.getItem('pro_name')) {
            var pro_name = JSON.parse(localStorage.getItem('pro_name'))
            // console.log(pro_name)
            return (
                <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                    <span className="profile_name">{pro_name}</span>
                </div>
            )
        } else {
            return (
                <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                    <span className="profile_name">{this.state.user.first_name}</span>
                </div>
            )
        }
    }

    render() {
        var local_storage = JSON.parse(localStorage.getItem('info'))
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div className="input_name">
                    {this.profilePic()}
                    <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="profile_name"> {local_storage.first_name} </span>
                    </div>
                    <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="blue_text content_dertails"><Link to={'/seller-edit-profile'} >{this.props.t('6')}</Link></span>
                    </div>
                </div>
            )
        } else if (isDesktop) {
            return (
                <div className="input_name">

                    {this.profilePic()}
                    {this.profileName()}
                    {/* <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="profile_name"> {local_storage.first_name} </span>
                    </div> */}
                    <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="blue_text content_dertails"><Link to={'/seller-edit-profile'} >{this.props.t('6')}</Link></span>
                    </div>
                    <div className="mt-5 input_name content_dertails guide_text" style={{ width: '85%', marginLeft: '10px' }}>
                        {this.props.t('1')}
                </div>
                    <div className="bigger_pad pt-0">
                        <table className="sidebar_table">
                            <tbody>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-dashboard'} className="color_alt sidebar_font">{this.props.t('2')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-transaction'} className="color_alt sidebar_font" href="/seller-transaction">{this.props.t('13')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/request-home'} className="color_alt sidebar_font" href="/request-home">{this.props.t('3')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/service-list'} className="color_alt sidebar_font" href="/service-list">{this.props.t('0')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/sales'} className="color_alt sidebar_font">{this.props.t('14')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/my-points'} className="color_alt sidebar_font" href="/my-points">{this.props.t('15')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/followers'} className="color_alt sidebar_font" href="/followers">{this.props.t('8')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div className="bigger_pad">
                        <Link to={'/product-upload'}>
                            <button className="sell">{this.props.t('16')}</button>
                        </Link>
                    </div>
                    <div className="mt-4 input_name content_dertails guide_text" style={{ width: '85%', marginLeft: '10px' }} >
                        {this.props.t('4')}
                            </div>
                    <div className="bigger_pad pt-0">
                        <table className="sidebar_table">
                            <tbody>

                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-buyer-transaction'} className="color_alt remove_underline sidebar_font" href="/seller-buyer-transaction">{this.props.t('17')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-buyer-request-home'} className="color_alt remove_underline sidebar_font" href="/seller-buyer-request-home">{this.props.t('9')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/purchase-list'} className="color_alt remove_underline sidebar_font">{this.props.t('18')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-favorites'} className="color_alt sidebar_font" href="/seller-favorites">{this.props.t('10')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-followers-buyer'} className="color_alt sidebar_font" href="/seller-followers-buyer">{this.props.t('19')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    <div className="bigger_pad">
                        <table style={{ width: "90%", fontSize: "18px", borderCollapse: "separate", borderSpacing: "10px", }}>
                            <tbody>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-buyer-direct-message-list'} className="color_alt sidebar_font">{this.props.t('11')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-change-password'} className="color_alt sidebar_font" href="">{this.props.t('5')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>


                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/'} className="color_alt sidebar_font" onClick={this.handleSubmit.bind(this)}>{this.props.t('12')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            )
        }
    }
}
export { SideBar }
SideBar = withRouter(SideBar);


 SideBar = withTranslation('src_Components_Common_SideBar')(SideBar);
